import { ADD_ALERTS, ALERTS_API_REQUEST, ALERTS_API_SUCCESS, ALERTS_API_FAILURE } from './actionTypes';
import fetchErrorHandler from '../services/fetchErrorHandler';
import { getCsrfToken } from '../utils/helpers';

const alertsApiRequest = () => ({
  type: ALERTS_API_REQUEST,
});

const alertsApiSuccess = () => ({
  type: ALERTS_API_SUCCESS,
});

const alertsApiFailure = ({ error }) => ({
  type: ALERTS_API_FAILURE,
  error,
});

const addAlerts = ({ count, results }) => ({
  type: ADD_ALERTS,
  payload: {
    count,
    results,
  },
});

const getAlerts = () => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;
  const { applicationId } = getState().user;
  const url = `${locale}/api/${apiVersion}/application/${applicationId}/alerts/?get_latest=true`;
  dispatch(alertsApiRequest());
  return fetch(url, {
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(data => {
      const { count, results } = data;
      // move LackCurrSchl alert on top
      const indexAlert = results.findIndex(obj => obj.code === 'LackCurrSchl');
      if (indexAlert !== -1) {
        const currentSchoolAlert = results.splice(indexAlert, 1)[0];
        results.unshift(currentSchoolAlert);
      }
      dispatch(
        addAlerts({
          count,
          results,
        }),
      );
      dispatch(alertsApiSuccess());
    })
    .catch(error => {
      console.error('error', error);
      dispatch(alertsApiFailure({ error }));
    });
};

export default getAlerts;
